import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTIVATION_OBJECT_QUERY_KEY } from "app/pages/activation/queries/data/useActivationObjectQuery";
import { createActivationApi } from "app/pages/activation/services/api";

import type { FirstPartyDataSource } from "../../types/api";

import { ACTIVATION_OBJECTS_QUERY_KEY } from "./useActivationSetListQuery";

export const useUpdateTrafficSourceMutation = (activationId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (trafficSource: FirstPartyDataSource) => {
            const api = createActivationApi();

            return api.activation.updateTrafficSource(activationId, trafficSource);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [ACTIVATION_OBJECT_QUERY_KEY, activationId] });
            queryClient.invalidateQueries({ queryKey: [ACTIVATION_OBJECTS_QUERY_KEY] });
        },
    });
};
